import { render } from "./BaseEditDialog.vue?vue&type=template&id=3417bdf4"
import script from "./BaseEditDialog.vue?vue&type=script&lang=js"
export * from "./BaseEditDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__